module.exports = __webpack_public_path__ + "img/leaguelogo.ca0428b1.png";